import { Box, Typography } from '@mui/material';
import { type TRPCClientErrorBase } from '@trpc/client';
import { type TRPCDefaultErrorShape } from '@trpc/server';
import { type OptionsWithExtraProps } from 'notistack';
import { Link } from 'react-router';

import { url } from '../../appRouter/url.ts';
import { type SnackbarGenerator } from './snackbars.types.tsx';

const createDurchgangSnackbarErrorOptions: OptionsWithExtraProps<'error'> = {
  variant: 'error',
  persist: true,
};

export const generateCreateDurchgangErrorSnackbar: SnackbarGenerator<TRPCClientErrorBase<TRPCDefaultErrorShape>> = (
  error,
) => ({
  message: 'Fehler beim Speichern des Durchgangs',
  options: {
    ...createDurchgangSnackbarErrorOptions,
    additional: error.message,
  },
});

export const generateCreateDurchgangErrorSnackbarWithFehlerId: SnackbarGenerator<{
  error: TRPCClientErrorBase<TRPCDefaultErrorShape>;
  fehlerId: string;
}> = ({ error, fehlerId }) => ({
  message: 'Fehler beim Speichern des Durchgangs',
  options: {
    ...createDurchgangSnackbarErrorOptions,
    additional: (
      <div>
        <p>Es trat ein Fehler beim Speichern des Durchgangs auf. Wende dich bitte mit Fehler-ID</p>
        <p>{fehlerId}</p>
        <p>an das VAMOS Team.</p>
        <p>{error.message}</p>
      </div>
    ),
  },
});

export const generateCreateDurchgangSuccessSnackbar: SnackbarGenerator<string> = (akaDurchgangId) => ({
  message: 'Durchgang gespeichert',
  options: {
    variant: 'success',
    additional: (
      <Box>
        <Typography component="span">Durchgang mit ID </Typography>
        <Link to={url.durchgang.details(akaDurchgangId)} target="_blank" rel="noopener">
          {akaDurchgangId}
        </Link>
        <Typography component="span"> wurde erfolgreich gespeichert!</Typography>
      </Box>
    ),
  },
});
